export const SET_DIALOG = "@dialog/set-dialog";
export const SET_PHONE = "@dialog/set-phone";


export function setDialog(name:string, status:Boolean, props?:any) {
  return async (dispatch:(val:any)=>void ) => {
    try {
      dispatch({
        type: SET_DIALOG,
        payload: {
          name: name,
          status: status,
          props: props,
        },
      });
    } catch (_) {
    }
  };
}

export function setPhone(phoneNumber:string) {
  return async (dispatch:(val:any)=>void ) => {
    try {
      dispatch({
        type: SET_PHONE,
        payload: {
          phoneNumber: phoneNumber,
        },
      });
    } catch (_) {
    }
  };
}